<script setup>
/**
 * KaptionSalesforceChannelStrip — salesforce-channel read-only notice.
 *
 * Sits on top of the reply box while the account's Salesforce owns the conversation (an open
 * Partner Messaging session, conversation.additional_attributes.kaption_salesforce_channel.owned).
 * The composer stays in private-note mode underneath; there is no take-over: replies to the
 * customer are written in Salesforce. The server enforces the same rule (MessagesController
 * ensure_not_salesforce_owned).
 *
 * NOTICE: KAPTION-INTEGRATION
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  conversation: { type: Object, required: true },
});

const { t } = useI18n();

const state = computed(
  () =>
    props.conversation?.additional_attributes?.kaption_salesforce_channel || {}
);

const title = computed(() => {
  if (state.value.owner_name) {
    return t('KAPTION_PLATFORM.SALESFORCE_CHANNEL.ANSWERING', {
      name: state.value.owner_name,
    });
  }
  if (state.value.queue_position) {
    return t('KAPTION_PLATFORM.SALESFORCE_CHANNEL.IN_QUEUE', {
      position: state.value.queue_position,
    });
  }
  return t('KAPTION_PLATFORM.SALESFORCE_CHANNEL.HANDLED');
});
</script>

<template>
  <div
    data-testid="kaption-salesforce-channel-strip"
    class="flex items-center gap-2 px-3 py-2 mx-2 mb-2 rounded-lg bg-n-blue-2 outline outline-1 outline-n-blue-6"
  >
    <span class="i-lucide-cloud size-4 shrink-0 text-n-blue-10" />
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-n-slate-12">
        {{ title }}
      </p>
      <p class="text-xs text-n-slate-11">
        {{ t('KAPTION_PLATFORM.SALESFORCE_CHANNEL.READ_ONLY') }}
      </p>
    </div>
  </div>
</template>
